export class Session {

    private authBasic: string;
    private clientUuid: string;
    private clienteValePresenteFreteGratuito: boolean;
    private isVoucher: boolean;

    public getAuthBasic() {
        return this.authBasic;
    }

    public getClientUuid() {
        return this.clientUuid;
    }

    public getClienteVale() {
        return this.clienteValePresenteFreteGratuito;
    }

    public getIsVoucher() {
        return this.isVoucher;
    }

}



// WEBPACK FOOTER //
// ./src/app/resources/classes/session.ts